export const STEPS_TABLE_ID = "STEPS";
